import { useState } from "react";

import classNames from "classnames";

import { Box } from "@jti/core-components/components/Box";
import type { ConsentSectionConfiguration } from "@jti/fe-common";

import { ConsentMandatoryCheckbox } from "./components/ConsentMandatoryCheckbox";
import { ConsentRadioGroup } from "./components/ConsentRadioGroup";

import styles from "./ConsentBlock.module.scss";

type ConsentBlockProps = {
  onChange: (value: boolean) => void;
  showError?: boolean;
  isMandatory?: boolean;
} & ConsentSectionConfiguration;

export const ConsentBlock = ({
  onChange,
  showError,
  agreeRadioLabel,
  rejectRadioLabel,
  consentSectionTitle,
  consentSectionSubtitle,
  isMandatory,
  errorText,
  ...rest
}: ConsentBlockProps) => {
  const [selectedValue, setSelectedValue] = useState<string>("");
  const onRadioGroupChange = (value: string) => {
    setSelectedValue(value);
    onChange(value === "true");
  };

  const onCheckboxChange = (checked: boolean) => {
    setSelectedValue(checked ? "true" : "false");
    onChange(checked);
  };

  return (
    <div
      className={classNames({ [styles.consentBlockContainer]: !isMandatory, [styles.error]: showError })}
      data-testid="pdp-consent-block"
    >
      <Box title={consentSectionTitle}>
        {consentSectionSubtitle && <div className={styles.subtitle}>{consentSectionSubtitle}</div>}

        {isMandatory ? (
          <ConsentMandatoryCheckbox
            checkboxLabel={agreeRadioLabel}
            shortHtml={rest.shortHtml}
            longHtml={rest.longHtml}
            showMoreBenefitsButtonLabel={rest.showMoreBenefitsButtonLabel}
            showLessBenefitsButtonLabel={rest.showLessBenefitsButtonLabel}
            onCheckedChange={onCheckboxChange}
            checked={selectedValue === "true"}
            errorText={errorText}
            isError={showError}
          />
        ) : (
          <ConsentRadioGroup
            name="consent-radio-group"
            agreeRadioLabel={agreeRadioLabel}
            rejectRadioLabel={rejectRadioLabel}
            shortHtml={rest.shortHtml}
            longHtml={rest.longHtml}
            showMoreBenefitsButtonLabel={rest.showMoreBenefitsButtonLabel}
            showLessBenefitsButtonLabel={rest.showLessBenefitsButtonLabel}
            onRadioGroupChange={onRadioGroupChange}
            selectedValue={selectedValue}
          />
        )}
      </Box>
    </div>
  );
};
